import {CONSTANTS} from "@k/js/meta_data"
import {ContentWithLevel, EnumDictionary, GetParametersDecoded} from "@k/js/delme_globals"
import {IEntwurfStoreWrapper} from "@k/js/EntwurfStateWrapper";
import {IUserWrapper} from "@k/js/userWrapper"
import {ILogoPoolStore} from "@k/js/user"
import {IOwayoDataModel} from "@k/js/model"
import {Store} from "vuex";
import {Product} from "@k/js/product"
import {LinksToWebsite} from "@k/js/databaseInterfaceClasses";
import {Linkersteller} from "@k/js/controllerModules/Linkersteller";
import axios from "axios";
import {EventVerteiler} from "@k/global/eventVerteiler";
import {CONTROLLER_EVENTNAMES} from "@k/global/GlobalEventnames";


type initFromGetParametersParameters = {
    lang: string,
    land: string,
    domain: string,
    infoFromGetParameters: GetParametersDecoded,
}

type ModelStoreState = {
    currentOwayoProduct: null | Product,
    sprache: string,
    domain: string,
    owayoDirectLogin: boolean,
    land: string,
    locale: string,
    globalRabattCode: string,
    waehrung: string,
    lieferland: string,
    kundenKonfi: string,
    webSportFuerProduktAuswahlInt: string,
    websportFuerProduktAuswahlNormalized: string,
    internationalLinks: EnumDictionary<LinksToWebsite, string>,
    contactData:string[][][]
}

export default {
    namespaced: true,
    state: () => ({
        currentOwayoProduct: null as null | Product,
        sprache: "de",
        domain: "",
        owayoDirectLogin: false,
        land: "de",
        locale: "",
        globalRabattCode: "",
        waehrung: "",
        lieferland: "",
        kundenKonfi: "",
        webSportFuerProduktAuswahlInt: "",
        websportFuerProduktAuswahlNormalized: "",
        internationalLinks: {
            angebotsService: "",
            agbs: "",
            musterservice: "",
            faq: "",
            lieferzeit: "",
            howToOrder: "",
            product: "",
            privacyterms: ""
        },
        contactData:[] as string[][][]
    } as ModelStoreState),
    getters: {
        getCurrentOwayoProduct: (state: ModelStoreState) => state.currentOwayoProduct,
        getSprache: (state: ModelStoreState) => state.sprache,
        getDomain: (state: ModelStoreState) => state.domain,
        getOwayoDirectLogin: (state: ModelStoreState) => state.owayoDirectLogin,
        getLand: (state: ModelStoreState) => state.land,
        getLanguage: (state: ModelStoreState) => state.sprache,
        getLocale: (state: ModelStoreState) => state.locale,
        getGlobalRabattCode: (state: ModelStoreState) => state.globalRabattCode,
        getWaehrung: (state: ModelStoreState) => state.waehrung,
        getLieferland: (state: ModelStoreState) => state.lieferland,
        getKundenKonfi: (state: ModelStoreState) => state.kundenKonfi,
        getWebSportFuerProduktAuswahlInt: (state: ModelStoreState) => state.webSportFuerProduktAuswahlInt,
        getWebsportFuerProduktAuswahlNormalized: (state: ModelStoreState) => state.websportFuerProduktAuswahlNormalized,
        getAuwiSportFuerProduktAuswahl: (state: ModelStoreState) => {
            switch(state.websportFuerProduktAuswahlNormalized) {
                case "radsport":
                    return "Bike";
                case "fussball":
                    return "Fußball";
                default:
                    return state.websportFuerProduktAuswahlNormalized;
            }
        },
        getLinkToWebsite:(state:ModelStoreState)=>(link:LinksToWebsite)=>state.internationalLinks[link],
        getLanguageIso: (state: ModelStoreState) => {
            if (state.land === "us" && state.sprache !== "es") {
                return state.land;
            }
            if (state.land.toLowerCase() === "ca" && state.sprache.toLowerCase() === "fr") {
                return state.sprache;
            }
            if (CONSTANTS.LAENDER_WHERE_LAND_IST_LANGUAGE_ISO.indexOf(state.land.toLowerCase()) > -1) {
                return state.land;
            }
            return state.sprache;
        },
        getContactData:(state:ModelStoreState)=>state.contactData

    },
    mutations: {
        initFromGetParameters(state: ModelStoreState, payload: initFromGetParametersParameters): void {
            state.sprache = payload.lang;
            state.land = payload.land;
            state.lieferland = payload.land;
            state.domain = payload.domain;
            state.webSportFuerProduktAuswahlInt = payload.infoFromGetParameters.sportFuerProduktauswahl.webInZielsprache;
            state.locale = payload.infoFromGetParameters.locale;
            state.globalRabattCode = payload.infoFromGetParameters.rabattCode;
            state.websportFuerProduktAuswahlNormalized = payload.infoFromGetParameters.sportFuerProduktauswahl.webNormalized;
            state.kundenKonfi = (payload.infoFromGetParameters.kundenKonfi !== "") ? payload.infoFromGetParameters.kundenKonfi : "";
        },
        setLieferland(state: ModelStoreState, lieferland: string): void {
            state.lieferland = lieferland;
        },

        setGlobalRabattCode(state: ModelStoreState, rabattCode): void {
            state.globalRabattCode = rabattCode;
        },

        SET_CURRENT_OWAYO_PRODUCT(state: ModelStoreState, product: Product): void {
            state.currentOwayoProduct = product;
        },

        setWebsportFuerProduktAuswahlNormalized(state: ModelStoreState, derived_sport: string): void {
            state.websportFuerProduktAuswahlNormalized = derived_sport;
        },
        setWebsportFuerProduktAuswahlInt(state: ModelStoreState, derived_sportInt: string): void {
            state.webSportFuerProduktAuswahlInt = derived_sportInt;
        },
        SET_WEBSITE_LINKS(state:ModelStoreState, links:EnumDictionary<LinksToWebsite, string>):void {
            state.internationalLinks = links;
        },
        SET_CONTACT_DATA(state:ModelStoreState, contactParagraphs) {
            state.contactData = contactParagraphs;
        }

    },
    actions: {
        loadInternationalLinks:(context)=>{
            const contentArray = [
                new ContentWithLevel("angebotsService", 1),
                new ContentWithLevel("agbs", 1),
                new ContentWithLevel("musterservice", 1),
                new ContentWithLevel("faq_neu", 1),
                new ContentWithLevel("lieferzeit_neu", 1),
                new ContentWithLevel("wieBestelleIch", 1),
                new ContentWithLevel("product", 2),
                new ContentWithLevel("datenschutzerklaerung", 1)
            ]
            getLinksToWebsite(contentArray,
                context.getters.getCurrentOwayoProduct,
                context.getters.getLand,
                context.getters.getWebSportFuerProduktAuswahlInt,
                context.getters.getLanguageIso).then(result=>context.commit("SET_WEBSITE_LINKS", result))
        },
        loadContactData:context=>{
            const lang = context.getters.getLanguage;
            const land = context.getters.getLand;

            axios.get("/konfigurator_php/mobile/getOwayoContactData.php?land="+land+"&lang="+lang).then((response)=>{
                context.commit("SET_CONTACT_DATA", response.data)
            })
        }

    },
}

export class ModelStoreWrapper implements IOwayoDataModel {
    entwurf: IEntwurfStoreWrapper;
    logoPool: ILogoPoolStore;
    user: IUserWrapper;
    private store: Store<any>;

    public constructor(store: Store<any>, entwurf: IEntwurfStoreWrapper, logoPool: ILogoPoolStore, user: IUserWrapper) {
        this.user = user;
        this.entwurf = entwurf;
        this.logoPool = logoPool;
        this.store = store;
    }



    getCurrentOwayoProduct = (): Product => this.store.getters["ModelStore/getCurrentOwayoProduct"];
    getDomain = (): string => this.store.getters["ModelStore/getDomain"];
    getGlobalRabattcode = (): string => this.store.getters["ModelStore/getGlobalRabattCode"];
    getKundenKonfi = (): string => this.store.getters["ModelStore/getKundenKonfi"];
    getLand = (): string => this.store.getters["ModelStore/getLand"];
    getLanguageIso = (): string => this.store.getters["ModelStore/getLanguageIso"];
    getLieferland = (): string => this.store.getters["ModelStore/getLieferland"];
    getLocale = (): string => this.store.getters["ModelStore/getLocale"];
    getSprache = (): string => this.store.getters["ModelStore/getSprache"];
    getWaehrung = (): string => this.store.getters["ModelStore/getWaehrung"];
    getWebSportFuerProduktAuswahlInt = (): string => this.store.getters["ModelStore/getWebSportFuerProduktAuswahlInt"];
    getWebsportFuerProduktAuswahlNormalized = (): string => this.store.getters["ModelStore/getWebsportFuerProduktAuswahlNormalized"];

    isOwayoDirectLogin = (): boolean => this.store.getters["ModelStore/getOwayoDirectLogin"];
    setCurrentOwayoProduct = (product: Product): void => {
        this.store.commit("ModelStore/SET_CURRENT_OWAYO_PRODUCT", product);
        this.store.dispatch("ModelStore/loadInternationalLinks");
        EventVerteiler.broadcast(CONTROLLER_EVENTNAMES.PRODUCT_INITIALIZED);
    }

    setGlobalRabattCode(rabattCode): void {
        this.store.commit("ModelStore/setGlobalRabattCode", rabattCode);
    }

    setLieferland(lieferland: string): void {
        this.store.commit("ModelStore/setLieferland", lieferland);
    }

    setWebsportFuerProduktAuswahlNormalized(derived_sport: string): void {
        this.store.commit("ModelStore/setWebsportFuerProduktAuswahlNormalized", derived_sport);
    }

    setWebsportFuerProduktAuswahlInt(derived_sportInt: string): void {
        this.store.commit("ModelStore/setWebsportFuerProduktAuswahlInt", derived_sportInt);
    }

    getDerivedUserDataPath(): string {
        return this.store.getters.getDerivedUserDataPath;
    }
}

function getLinksToWebsite(contentArray:ContentWithLevel[], currentOwayoProduct, land, sportWebInt, language) {
    return new Promise<EnumDictionary<LinksToWebsite, string>>(resolve => {

        if (currentOwayoProduct === null) {
            resolve({
                [LinksToWebsite.agbs]:"",
                [LinksToWebsite.faq]:"",
                [LinksToWebsite.angebotsService]:"",
                [LinksToWebsite.lieferzeit]:"",
                [LinksToWebsite.musterservice]:"",
                [LinksToWebsite.howToOrder]:"",
                [LinksToWebsite.privacyterms]:"",
                [LinksToWebsite.product]:""
            });
        }

        Linkersteller.getInternationalKonfiLinksPromise({
            land: land,
            sportWebInt: sportWebInt,
            sprache: language,
            contentArray,
            productWebInt:currentOwayoProduct.productWebInt
        }).then(result=>{
            resolve({
                [LinksToWebsite.agbs]:result.agbs,
                [LinksToWebsite.faq]:result.faq_neu,
                [LinksToWebsite.angebotsService]:result.angebotsService,
                [LinksToWebsite.lieferzeit]:result.lieferzeit_neu,
                [LinksToWebsite.musterservice]:result.musterservice,
                [LinksToWebsite.howToOrder]:result.wieBestelleIch,
                [LinksToWebsite.privacyterms]:result.datenschutzerklaerung,
                [LinksToWebsite.product]:result.product
            });
        })
    })
}
